import styled from "styled-components";
import { readOnlyColor } from "../../../fields/Styles";

const FieldContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 8px;
`

const GitBranchField = ({ hub }) => {
    return <>
        <FieldContainer>
            <div style={{color: readOnlyColor}}>{hub.gitBranch || 'Unknown'}</div>
        </FieldContainer>
    </>
}

export default GitBranchField;
